import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={40}
            height={41}
            viewBox="0 0 40 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g filter="url(#filter0_b_1956_159413)">
                <path
                d="M.784 13.626a16.692 16.692 0 0112.44-12.44 29.675 29.675 0 0113.553 0 16.692 16.692 0 0112.439 12.44 29.674 29.674 0 010 13.553 16.692 16.692 0 01-12.44 12.44 29.676 29.676 0 01-13.553 0A16.692 16.692 0 01.784 27.178a29.675 29.675 0 010-13.553z"
                fill="#B4E3E1"
                />
            </g>
            <path
                d="M25.5 24.07v-1.167a1.167 1.167 0 00-2.334 0v1.167m3.5-5H13.333m13.333.666V17.87c0-.747 0-1.12-.145-1.406a1.333 1.333 0 00-.583-.582c-.285-.146-.658-.146-1.405-.146h-9.067c-.746 0-1.12 0-1.405.146-.25.127-.455.332-.583.582-.145.286-.145.659-.145 1.406v5.066c0 .747 0 1.12.145 1.406.128.25.332.455.583.582.285.146.659.146 1.405.146h3.867m3.733 1.666H25.6c.373 0 .56 0 .702-.072a.666.666 0 00.292-.292c.072-.142.072-.329.072-.702v-.534c0-.373 0-.56-.072-.702a.666.666 0 00-.292-.292c-.142-.072-.329-.072-.702-.072h-2.534c-.373 0-.56 0-.702.072a.667.667 0 00-.292.292c-.072.142-.072.329-.072.702v.534c0 .373 0 .56.072.702a.667.667 0 00.292.292c.142.072.329.072.702.072z"
                stroke="#0D968F"
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <filter
                id="filter0_b_1956_159413"
                x={-8}
                y={-7.59766}
                width={56}
                height={56}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
                >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feGaussianBlur in="BackgroundImageFix" stdDeviation={4} />
                <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_1956_159413"
                />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_1956_159413"
                    result="shape"
                />
                </filter>
            </defs>
        </svg>
    )
}
  
  export default SvgComponent